import { trans } from '@spotahome/soyuz/client';
import { structureFaqs } from '@spotahome/ui-library/src/utils/faqs';

const getFaqKeys = () => [
  {
    top: 'how-it-works.faqs.item-1.title',
    content: 'how-it-works.faqs.item-1.content'
  },
  {
    top: 'how-it-works.faqs.item-2.title',
    content: 'how-it-works.faqs.item-2.content'
  },
  {
    top: 'how-it-works.faqs.item-3.title',
    content: 'how-it-works.faqs.item-3.content'
  },
  {
    top: 'how-it-works.faqs.item-4.title',
    content: 'how-it-works.faqs.item-4.content'
  },
  {
    top: 'how-it-works.faqs.item-5.title',
    content: 'how-it-works.faqs.item-5.content'
  },
  {
    top: 'how-it-works.faqs.item-6.title',
    content: 'how-it-works.faqs.item-6.content'
  },
  {
    top: 'how-it-works.faqs.item-7.title',
    content: 'how-it-works.faqs.item-7.content'
  },
  {
    top: 'how-it-works.faqs.item-8.title',
    content: 'how-it-works.faqs.item-8.content'
  },
  {
    top: 'how-it-works.faqs.item-9.title',
    content: 'how-it-works.faqs.item-9.content'
  },
  {
    top: 'how-it-works.faqs.item-10.title',
    content: 'how-it-works.faqs.item-10.content'
  }
];

export const getFaqs = () =>
  getFaqKeys()
    .map(faq => ({
      top: trans(faq.top),
      content: trans(faq.content)
    }))
    .filter(Boolean);

export const getStructuredFaqs = transFn => {
  const faqs = getFaqKeys()
    .map(faq => ({
      top: transFn(faq.top),
      content: transFn(faq.content)
    }))
    .filter(Boolean);

  return structureFaqs(faqs);
};

export default {
  getFaqs,
  getStructuredFaqs
};
